// Bootstrap を読み込む（全ての Bootstrap のプラグインを bootstrap オブジェクトにロード）
import bootstrap from '../node_modules/bootstrap/dist/js/bootstrap';
// または const bootstrap = require('bootstrap')  でも同じ

window.bootstrap = bootstrap;

document.addEventListener('DOMContentLoaded', function () {
  // 既存のtooltip対象要素を先に初期化
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((element) => {
    if (!element.dataset.tooltipInitialized) {
      new bootstrap.Tooltip(element);
      element.dataset.tooltipInitialized = true;
    }
  });

  // MutationObserverで動的に追加されるtooltip対象要素を監視
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // 自身がtooltip対象かどうかチェック
          if (node.matches('[data-bs-toggle="tooltip"]') && !node.dataset.tooltipInitialized) {
            new bootstrap.Tooltip(node);
            node.dataset.tooltipInitialized = true;
          }
          // 内部のtooltip対象要素も初期化
          node.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
            if (!el.dataset.tooltipInitialized) {
              new bootstrap.Tooltip(el);
              el.dataset.tooltipInitialized = true;
            }
          });
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});


// スタイルシートを読み込む
import './custom.scss';
